<template>
  <v-app>
    <v-navigation-drawer v-model="drawer" app>
      <v-list-item>
        <v-list-item-avatar>
          <v-img src="@/assets/images/etx.png"></v-img>
        </v-list-item-avatar>
        <v-list-item-content>
          <v-list-item-title class="title">
            {{ user }}
          </v-list-item-title>
          <v-list-item-subtitle>
            Administrator
          </v-list-item-subtitle>
        </v-list-item-content>
      </v-list-item>
      <v-divider></v-divider>
      <v-list dense nav>
        <v-list-item-group>
          <v-list-item
            v-for="(item, i) in items"
            :key="i"
            link
            @click="activeCard(item.title)"
            :to="item.link"
            router
            exact
          >
            <v-list-item-icon>
              <v-icon>{{ item.icon }}</v-icon>
            </v-list-item-icon>

            <v-list-item-content>
              <v-list-item-title>{{ item.title }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list-item-group>
      </v-list>
    </v-navigation-drawer>

    <v-app-bar app dark color="primary">
      <v-app-bar-nav-icon @click="drawer = !drawer"></v-app-bar-nav-icon>
      <v-toolbar-title>{{ activeCardText }}</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn icon @click.native="modalChangePasswordOpen">
        <v-icon>mdi-account-circle</v-icon>
      </v-btn>
      <v-btn icon @click.native="logout">
        <v-icon>mdi-export</v-icon>
      </v-btn>
    </v-app-bar>

    <v-main class="pb-16">
      <v-container>
        <v-row>
          <v-col>
            <router-view />
          </v-col>
        </v-row>
      </v-container>
    </v-main>

    <v-footer absolute class="font-weight-medium">
      <div class="footer-wrapper">
        <img src="../assets/images/chiesi-logo.png" alt="" class="img-fluid" />
      </div>
    </v-footer>

    <ChangePasswordModal :open="open" @close="close" />
    <Snackbar :snackbar="snackbar" :snackbarStatus="snackbarStatus" />
  </v-app>
</template>

<script>
import ChangePasswordModal from "@/components/ChangePasswordModal.vue";
import Snackbar from "@/components/Snackbar.vue";

export default {
  components: {
    ChangePasswordModal,
    Snackbar
  },
  data() {
    return {
      drawer: null,
      activeCardText: "Lekarze",
      user: sessionStorage.getItem("loggedInUser") || "",
      items: [
        {
          title: "Lekarze",
          icon: "mdi-account",
          link: "/dashboard/"
        },
        {
          title: "Pacjenci",
          icon: "mdi-account-box",
          link: "/dashboard/patients"
        },
        {
          title: "Statystyki",
          icon: "mdi-chart-line",
          link: "/dashboard/statistics"
        },
        {
          title: "Administratorzy",
          icon: "mdi-account-box-outline",
          link: "/dashboard/admin"
        },
        {
          title: "Powiadomienia",
          icon: "mdi-message-text",
          link: "/dashboard/pushes"
        }
      ],
      open: false,
      snackbar: false,
      snackbarStatus: false
    };
  },
  methods: {
    activeCard(activeLink) {
      this.activeCardText = activeLink;
    },
    logout() {
      sessionStorage.removeItem("loggedIn");
      sessionStorage.removeItem("loggedInUser");
      sessionStorage.removeItem("pathname");
      this.$router.push("/");
    },
    modalChangePasswordOpen() {
      this.open = true;
    },
    close(status) {
      if (status !== "close") {
        this.snackbar = true;
        this.snackbarStatus = status;
      }
      this.open = false;
    }
  }
};
</script>

<style lang="scss" scoped>
main {
  min-height: 100%;
}
a {
  text-decoration: none;
  color: initial;
  width: 100%;
}
.footer-wrapper {
  width: 100%;
  height: 48px;
  text-align: right;
}
</style>
